import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import LoadingSpinner from '../shared/LoadingSpinner';

const ProtectedRoute = ({ children, allowedRoles = [] }) => {
    const { user, loading } = useAuth();

    if (loading) {
        return <LoadingSpinner />;
    }

    if (!user) {
        return <Navigate to="/login" replace />;
    }

    if (allowedRoles.length > 0 && !allowedRoles.includes(user.user_type)) {
        // Redirect to appropriate dashboard based on user type
        if (user.user_type === 'student') {
            return <Navigate to="/student/dashboard" replace />;
        } else if (user.user_type === 'parent' || user.user_type === 'teacher') {
            return <Navigate to="/parent/dashboard" replace />;
        } else if (user.user_type === 'admin') {
            return <Navigate to="/admin/dashboard" replace />;
        }
        return <Navigate to="/" replace />;
    }

    return children;
};

export default ProtectedRoute;